import React from "react";

/* Carosello delle immagini dello studio: scorre da solo, immagini piccole,
   non cliccabili e non ingrandibili. Si ferma al passaggio del mouse. */

const DIDASCALIE = [
  "Due professioniste dello studio al lavoro su un report",
  "Silvia Casali alla scrivania del suo studio",
  "Il corridoio dello studio SC Dottori Commercialisti a Ravenna",
  "Gli spazi di lavoro dello studio SC Dottori Commercialisti",
  "Una riunione di lavoro nello studio",
  "Il team dello studio durante una pausa",
  "Un incontro di consulenza con gli imprenditori",
  "La sala di attesa dello studio",
  "L'analisi dei numeri di un'azienda",
  "La scrivania di lavoro dello studio"
];

const FOTO = DIDASCALIE.map((alt, i) => ({
  src: `/images/studio/studio-${String(i + 1).padStart(2, "0")}.webp`,
  alt
}));

export const CaroselloStudio = ({ tono = "chiaro", testid = "carosello-studio" }) => {
  const lista = [...FOTO, ...FOTO];
  const bordo = tono === "scuro" ? "border-white/15" : "border-[#E8E2D5]";
  const sfumatura = "linear-gradient(90deg, rgba(0,0,0,0) 0%, #000 6%, #000 94%, rgba(0,0,0,0) 100%)";

  return (
    <div
      className="relative overflow-hidden select-none"
      data-testid={testid}
      style={tono === "scuro" ? undefined : { WebkitMaskImage: sfumatura, maskImage: sfumatura }}
    >
      <style>{`
        @keyframes sc-scorri { from { transform: translate3d(0,0,0); } to { transform: translate3d(-50%,0,0); } }
        .sc-nastro { animation: sc-scorri 60s linear infinite; }
        .sc-nastro:hover { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) { .sc-nastro { animation: none; } }
      `}</style>
      <div className="sc-nastro flex gap-4 w-max">
        {lista.map((f, i) => (
          <img
            key={i}
            src={f.src}
            alt={i < FOTO.length ? f.alt : ""}
            aria-hidden={i >= FOTO.length}
            loading="lazy"
            decoding="async"
            draggable="false"
            className={`h-28 md:h-36 w-auto rounded border ${bordo} object-cover pointer-events-none`}
          />
        ))}
      </div>
      {tono === "scuro" && (
        <>
          <div className="absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-[#0D1527] to-transparent" />
          <div className="absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#0D1527] to-transparent" />
        </>
      )}
    </div>
  );
};
